// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Merriweather_a6078f', '__Merriweather_Fallback_a6078f'"},"className":"__className_a6078f"};